var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"person-name"},[_vm._v(" "+_vm._s(_vm.person.first_name + ' ' + _vm.person.last_name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }